import { ElCarousel, ElCarouselItem } from 'element-plus';
import 'element-plus/es/components/carousel/style/css'
import 'element-plus/es/components/carousel-item/style/css'

import PageFooter from "./PageFooter.vue";
export default {
  props: {
    attr: {}
  },
  components: {
    ElCarousel,
    ElCarouselItem,
    PageFooter
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile);
  },
  data() {
    return {
      isMobile: false,
      sloganList: [require("../assets/home/slogan/0.webp"), require("../assets/home/slogan/1.webp"), require("../assets/home/slogan/2.webp")],
      desktopPicList: [require("../assets/home/background/0.webp"), require("../assets/home/background/1.webp"), require("../assets/home/background/2.webp")],
      mobilePicList: [require("../assets/home/background/0_mobile.webp"), require("../assets/home/background/1_mobile.webp"), require("../assets/home/background/2_mobile.webp")],
      screenSize: [0, 0],
      swiperHeight: "100vh",
      selectedBriefIndex: 0,
      briefList: ["Trusted by veterinary professionals worldwide, Allvita delivers scientifically formulated products that support your pet's well-being with the quality and care.", "Allvita offers premium pet care products that combine cutting-edge veterinary science with global standards, ensuring your pet’s health is in the best hands, at an affordable price.", "Our carefully crafted pet products are designed to meet the highest veterinary standards, providing your pets with the best care possible for a healthier, happier life."],
      briefColorList: ["#2C2B2B", "#2C2B2B", "#2C2B2B"],
      touchStartX: 0,
      touchEndX: 0
    };
  },
  computed: {
    picList() {
      return this.isMobile ? this.mobilePicList : this.desktopPicList;
    }
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
    changePic(next) {
      // console.log([prev, next])

      window.$(".textArea").css("opacity", "0");
      this.selectedBriefIndex = next;
      setTimeout(function () {
        this.$(".textArea").css("opacity", "1");
      }, 200);
    },
    handleTouchStart(e) {
      this.touchStartX = e.changedTouches[0].screenX;
    },
    handleTouchEnd(e) {
      this.touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe();
    },
    handleSwipe() {
      if (this.touchEndX < this.touchStartX - 50) {
        this.$refs.swiper.next();
      }
      if (this.touchEndX > this.touchStartX + 50) {
        this.$refs.swiper.prev();
      }
    }
  }
};